import { FETCH_ORG_LIST} from "../actions/type";
const initialState = {
    organisation:[],
    users_md:'',
    loading:true
}
const manageorganizatonReducer = (state = initialState, action) => {
    const newState = { ...state };
    switch (action.type) {
        case FETCH_ORG_LIST:
            return {
                ...state,
                organisation: [...action.organisation],
                users_md: action.users_md,
                md_name_cond:action.md_name_cond,
                loading:false
            }
        default:
            break;
    }
    return newState;
}
export { manageorganizatonReducer }


// WEBPACK FOOTER //
// ./src/reducers/manageorganizatonReducer.js